// Mirrors libs/nest-lib/src/lib/interfaces/files/file-purpose.enum.ts.
// Keep in sync when adding new purposes server-side.
export enum FilePurpose {
  NIN = 'NIN',
  INTERNATIONAL_PASSPORT = 'INTERNATIONAL_PASSPORT',
  CAC = 'CAC',
  BIRTH_CERTIFICATE = 'BIRTH_CERTIFICATE',
  DRIVERS_LICENSE = 'DRIVERS_LICENSE',
  ID_CARD = 'ID_CARD',
  VOTERS_CARD = 'VOTERS_CARD',
  UTILITY_BILL = 'UTILITY_BILL',
  BANK_STATEMENT = 'BANK_STATEMENT',
  PAYSLIP = 'PAYSLIP',
  OTHER = 'OTHER',
  PROOF_OF_ADDRESS = 'PROOF_OF_ADDRESS',
  TAX_IDENTIFICATION_NUMBER = 'TAX_IDENTIFICATION_NUMBER',
  CAC_STATUS_REPORT = 'CAC_STATUS_REPORT',
  MEMORANDUM_AND_ARTICLES = 'MEMORANDUM_AND_ARTICLES',
  MEDICAL_LICENSE = 'MEDICAL_LICENSE',
  BOARD_CERTIFICATION = 'BOARD_CERTIFICATION',
  MALPRACTICE_INSURANCE = 'MALPRACTICE_INSURANCE',
  PROFESSIONAL_CERTIFICATE = 'PROFESSIONAL_CERTIFICATE',
  MEDICAL_SCHOOL_DIPLOMA = 'MEDICAL_SCHOOL_DIPLOMA',
  CONTINUING_EDUCATION_CERTIFICATE = 'CONTINUING_EDUCATION_CERTIFICATE',
  FACIAL_RECOGNITION = 'FACIAL_RECOGNITION',
  PROFILE_IMAGE = 'PROFILE_IMAGE',
  BANNER_IMAGE = 'BANNER_IMAGE',
  LOGO = 'LOGO',
  BANNER = 'BANNER',
  PRODUCT_IMAGE = 'PRODUCT_IMAGE',
  DOCUMENT = 'DOCUMENT',
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
  THUMBNAIL = 'THUMBNAIL',
}
